import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api";

function PasswordResetPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      // Przekierowanie na stronę główną, jeśli token jest nieobecny
      navigate("/", { replace: true });
    }
  }, [params, navigate]);

  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");

  const validatePassword = (password) => {
    const minLength = 6; // Example: .NET Identity default is 6
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return `Hasło musi mieć co najmniej ${minLength} znaków.`;
    }
    if (!hasUppercase) {
      return "Hasło musi zawierać co najmniej jedną wielką literę.";
    }
    if (!hasLowercase) {
      return "Hasło musi zawierać co najmniej jedną małą literę.";
    }
    if (!hasDigit) {
      return "Hasło musi zawierać co najmniej jedną cyfrę.";
    }
    if (!hasSpecialChar) {
      return "Hasło musi zawierać co najmniej jeden znak specjalny.";
    }
    return "";
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const error = validatePassword(newPassword);
    setPasswordError(error);

    // Check confirm password match on password change
    if (confirmPassword && newPassword !== confirmPassword) {
      setConfirmError("Hasła nie są takie same.");
    } else {
      setConfirmError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    if (password !== value) {
      setConfirmError("Hasła nie są takie same.");
    } else {
      setConfirmError("");
    }
  };

  const handlePasswordReset = () => {
    api
      .post("/Auth/reset-password", {
        resetToken: token,
        newPassword: password,
        email: email,
      })
      .then((response) => {
        if (response.status === 200) {
          setMessage("Hasło zostało pomyślnie zresetowane! Za chwilę nastąpi przekierowanie do logowania.");
          setTimeout(() => {
            navigate("/login", { replace: true });
          }, 2000); // Redirect after 2 seconds
        } else {
          setMessage("Nie udało się zresetować hasła. Spróbuj ponownie.");
        }
      })
      .catch((error) => {
        setMessage(error.response.data);
      });
  };

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Ustaw Nowe Hasło</h1>
      <div className="mb-3">
        <label htmlFor="email" className="form-label">
          <b>Potwierdź Email (Adres e-mail podany przy rejestracji)</b>
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Wpisz swój adres email"
        />
        <label htmlFor="password" className="form-label mt-2">
          <b>Nowe Hasło</b>
        </label>
        <input
          type={showPassword ? "text" : "password"}
          className={`form-control ${passwordError ? "is-invalid" : ""}`}
          id="password"
          value={password}
          onChange={handlePasswordChange}
          placeholder="Wpisz nowe hasło"
        />
        {passwordError && (
          <div className="invalid-feedback">{passwordError}</div>
        )}

        <label htmlFor="confirmPassword" className="form-label mt-2">
          <b>Powtórz Hasło</b>
        </label>
        <input
          type={showPassword ? "text" : "password"}
          className={`form-control ${confirmError ? "is-invalid" : ""}`}
          id="confirmPassword"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          placeholder="Powtórz nowe hasło"
        />
        {confirmError && <div className="invalid-feedback">{confirmError}</div>}

        <div className="form-check mt-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="showPassword"
            checked={showPassword}
            onChange={() => setShowPassword(!showPassword)}
          />
          <label className="form-check-label" htmlFor="showPassword">
            Pokaż Hasło
          </label>
        </div>
      </div>
      <button
        className="btn btn-primary"
        onClick={handlePasswordReset}
        disabled={
          !!passwordError ||
          !!confirmError ||
          !password ||
          !confirmPassword ||
          !email
        }
      >
        Zresetuj Hasło
      </button>
      {message && <div className="alert alert-info mt-3">{message}</div>}
    </div>
  );
}

export default PasswordResetPage;
